import AdBanner from '../../common/component/AdBanner';
import {IAdBanner} from '../../common/type';
import useViewerSettings from '../../commonSub/hook/useViewerSettings';
import {sendViewerEvent, sendViewerViewImp} from '../common';

interface IProps {
  contentId?: number;
  episodeId: number;
  banner: IAdBanner;
}

export default function EventBanner({contentId, episodeId, banner}: IProps) {
  const [{viewType}] = useViewerSettings(contentId);

  const onClickBanner = () => {
    sendViewerEvent({
      actionName: 'banner',
      action: 'click',
      customProps: {
        content_id: contentId,
        episode_id: episodeId,
        banner_id: banner.id,
        event_layer: 'event_banner',
        viewer_type: viewType,
        cardgroup_id: banner.cardgroupId,
      },
    });
  };

  const onIntersectionBanner = (isIntersecting: boolean) => {
    isIntersecting &&
      sendViewerViewImp({
        customProps: {
          content_id: contentId,
          episode_id: episodeId,
          banner_id: banner.id,
          event_layer: 'event_banner',
          viewer_type: viewType,
          cardgroup_id: banner.cardgroupId,
        },
      });
  };

  return (
    <AdBanner
      banner={banner}
      onClick={onClickBanner}
      onIntersection={onIntersectionBanner}
    />
  );
}
